module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-wrapper"
  }, [(_vm.urls || _vm.readonly) ? _c('div', {
    staticClass: "img-wrap"
  }, [(_vm.urls) ? _c('img', {
    attrs: {
      "src": _vm.urls,
      "alt": "图片"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.urls) ? _c('div', [_vm._v("暂无图片数据")]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('el-button', {
    staticClass: "img-close",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-cross"
  })]) : _vm._e()], 1) : _c('el-upload', {
    attrs: {
      "drag": "",
      "action": ("" + (_vm.$util.domain) + _vm.actionUrl),
      "with-credentials": true,
      "accept": "image/*",
      "name": "uploadFile",
      "type": "drag",
      "thumbnail-mode": true,
      "show-file-list": false,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "on-remove": _vm.onRemove
    }
  }, [_c('div', [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-dragger__text"
  }, [_vm._v("\n            将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip upload-tips",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.tips))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-655958f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UploadItems/UploadImage.vue
// module id = 1054
// module chunks = 0